import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Functionblock } from '../functionblocks/functionblocks.interfaces';
import { SceneExtension } from './sceneExtensions.interface';

@Injectable({
  providedIn: 'root',
})
export class SceneExtensionService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get scene extensions from parent output id
   * @param id parent output id
   */
  getScenes(id: number): Observable<SceneExtension[]> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/${id}`;
    return this.http.get<SceneExtension[]>(url);
  }

  /**
   * Get the parent output scene
   * @param id the id of the output
   * @returns observable of the parent output scene
   */
  getParentOutputScene(id: number): Observable<Functionblock> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/output/${id}`;
    return this.http.get<Functionblock>(url);
  }

  /**
   * Add a scene
   * @param functionblock the scene to add
   */
  addScene(functionblock: Functionblock): Observable<number> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/new`;
    return this.http.post<number>(url, functionblock);
  }

  /**
   * Update a scene
   * @param sceneExtension
   */
  updateScene(sceneExtensions: SceneExtension[]): Observable<void> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/add`;
    return this.http.post<void>(url, sceneExtensions);
  }

  /**
   * Delete a scene
   * @param id of the scene (functionblock)
   */
  deleteScene(id: number): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/${id}`;
    return this.http.delete<boolean>(url);
  }

  /**
   * Delete output from scene
   * @param id of the scene (functionblock)
   */
  deleteOutput(scene: SceneExtension): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/${scene.parentOutputId}/output/${scene.outputId}`;
    return this.http.delete<boolean>(url);
  }

  deleteSceneExtension(id: number): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/extension/${id}`;
    return this.http.delete<boolean>(url);
  }

  /**
   * Rename a scene
   * @param scene the scene to rename
   * @returns observable boolean indicating success
   */
  renameScene(scene: Functionblock): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtsceneextension/${scene.id}/rename`;
    return this.http.post<boolean>(url, { name: scene.name });
  }
}
